import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import {
  CompanyOfferService,
  PopulationQuery,
  CompanyOfferV2Model,
} from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';
import { HideMobileNav } from '@fgb/portal-component-library/src/lib/directives';

export enum CompanyOfferType {
  ExternalWebsite = 0,
  Discount = 1,
  CouponCode = 2,
  Affiliate = 3,
  NoAction = 4,
  SingleSignOn = 5,
  ThirdPartyOffer = 6,
  SingleCodeOffer = 7,
  UniqueCodeOffer = 8,
}

@Component({
  selector: 'fgb-brand-detail-page',
  templateUrl: './brand-detail-page.component.html',
  styleUrls: ['./brand-detail-page.component.scss'],
  hostDirectives: [HideMobileNav],
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ height: '0', overflow: 'hidden', opacity: 0 }),
        animate('200ms ease-out', style({ height: '*', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ height: '*', overflow: 'hidden', opacity: 1 }),
        animate('200ms ease-in', style({ height: '0', opacity: 0 })),
      ]),
    ]),
  ],
})
export class BrandDetailPageComponent implements OnInit {
  offer$: Observable<CompanyOfferV2Model | undefined>;
  descriptionOpen = true;
  tcsOpen = false;
  revealedCode: string | null = null;
  codeCopied = false;
  revealCodeError: string | null = null;
  readonly OfferType = CompanyOfferType;
  isClub1901: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyOfferService: CompanyOfferService,
    private populationQuery: PopulationQuery,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.isClub1901 = this.populationQuery.userInPopulation([Populations.Club1901]);
    const offerId = Number(this.route.snapshot.paramMap.get('id'));

    this.offer$ = this.companyOfferService.fetchOffersV2(0, 0).pipe(
      map((offers) => offers.find((o) => o.OfferId === offerId)),
      shareReplay(1)
    );
  }

  goBack() {
    this.router.navigate(['/brand']);
  }

  async claimOffer(offerId: number) {
    const result = await this.companyOfferService.claimOffer(offerId);
    if (result?.RedirectUrl) {
      window.open(result.RedirectUrl);
    }
  }

  copyCode() {
    if (!this.revealedCode) return;
    navigator.clipboard.writeText(this.revealedCode).then(() => {
      this.codeCopied = true;
      this.cdr.markForCheck();
      setTimeout(() => {
        this.codeCopied = false;
        this.cdr.markForCheck();
      }, 2000);
    });
  }

  async revealCode(offerId: number) {
    this.revealCodeError = null;
    try {
      const result = await this.companyOfferService.claimOffer(offerId);
      if (result?.Code) {
        this.revealedCode = result.Code;
        this.cdr.markForCheck();
      }
    } catch (err: any) {
      if (err?.error?.Code === 'Companies.CODE.90070') {
        this.revealCodeError = 'partner.codes.no.remaining';
        this.cdr.markForCheck();
      }
    }
  }
}
